import { render, staticRenderFns } from "./ManagementRegion.vue?vue&type=template&id=0c08d420&scoped=true&"
import script from "./ManagementRegion.vue?vue&type=script&lang=ts&"
export * from "./ManagementRegion.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementRegion.vue?vue&type=style&index=0&id=0c08d420&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c08d420",
  null
  
)

export default component.exports